import { get, post, put, remove } from "./api";
import type { WorkspaceDto } from "./NetTypes";

export async function getBuildInfo() {
  const { data } = await get({ path: `/buildInfo` });
  const license = await getLicenseInfo();
  return { ...data, ...license };
}

export async function getMyTeams(): Promise<
  { tenantId: string; tenantName: string; role: string; isDefault: boolean }[]
> {
  const { data } = await get({ path: `/teams/my-teams` });
  return data ?? [];
}

export async function switchTeam(tenantId: string): Promise<{ token: string }> {
  const { data } = await post({ path: `/teams/switch`, data: { tenantId } });
  return data;
}

export async function getSessions(): Promise<
  {
    sessionId: string;
    tenantId: string;
    tenantName: string;
    issuedAt: string;
    expiresAt: string;
    lastUsedAt?: string;
    deviceInfo?: string;
    createdBy: string;
  }[]
> {
  const { data } = await get({ path: `/sessions` });
  return data ?? [];
}

export async function revokeSession(sessionId: string): Promise<void> {
  await remove({ path: `/sessions/${sessionId}` });
}

export async function revokeAllSessions(): Promise<{ revokedCount: number }> {
  const res = await remove({ path: `/sessions/me` });
  return res?.data ?? { revokedCount: 0 };
}

export async function getLicenseInfo() {
  const { data } = await get({ path: `/licenseInfo` });
  return data;
}

export async function getTeamMembers() {
  const { data } = await get({ path: `/teams/members` });
  return data;
}

export async function activeTeamMember(accountId: string) {
  await get({ path: `/teams/members/${accountId}/active` });
}

export async function enableAdminTeamMember(accountId: string) {
  await get({ path: `/teams/members/${accountId}/enable-admin` });
}

export async function removeTeamMember(accountId: string) {
  await get({ path: `/teams/members/${accountId}/remove` });
}

export async function getTeamInfo() {
  const response = await get({ path: `/teams/team-info` });
  return response.data;
}

export async function updateTeamInfo(data: any) {
  const response = await put({
    path: `/teams/update-team-info`,
    data,
  });
  return response.data;
}

export async function getTeamPipelines(): Promise<WorkspaceDto[]> {
  const { data } = await get({ path: `/teams/pipelines` });
  return data ?? [];
}

export async function addJiraUsersToTeam(accountIds: string[]) {
  // Add Jira users to team by calling getUser for each accountId
  // This will automatically create/update users in the tenant
  const promises = accountIds.map((accountId) => get({ path: `/users/${accountId}` }));
  await Promise.all(promises);
}
